'use client'

import { Card, EmptyState, Animation } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { useAsset } from '@marketplace-web/shared/assets'

const ItemPerformanceEmptyState = () => {
  const translate = useTranslate('item_performance.empty_state')
  const asset = useAsset('/assets/animations')

  return (
    <Card>
      <div className="u-ui-padding-vertical-x-large" data-testid="bump-statistic-empty-state">
        <EmptyState
          title={translate('title')}
          body={translate('body')}
          icon={<Animation animationUrl={asset('feedback-empty-state.json')} />}
        />
      </div>
    </Card>
  )
}

export default ItemPerformanceEmptyState
